import { useMemo } from 'react';

import { useFindMatchesAndMismatches } from '../../hooks';
import { TagList } from '../tag-list';
import type { SkillTagListProps } from './types';

type CombinedSkillTagListProps = {
  maxSkillTagDisplayCount?: number;
} & SkillTagListProps;

export const CombinedSkillTagList = (props: CombinedSkillTagListProps) => {
  const {
    maxSkillTagDisplayCount: maxCount,
    skills,
    gitHubRepoDerivedUserSkillIds,
    userSelfRecommendedSkillIds,
  } = props;

  const { matches, mismatches } = useFindMatchesAndMismatches(skills, [
    ...gitHubRepoDerivedUserSkillIds,
    ...userSelfRecommendedSkillIds,
  ]);

  const combinedSkills = [...matches, ...mismatches];
  const totalSkills =
    maxCount === undefined ? combinedSkills : combinedSkills.slice(0, maxCount);

  const tags = useMemo(
    () =>
      totalSkills.map((tag) => ({
        key: tag.id,
        name: tag.name,
        isMatched: tag.isMatched,
      })),
    [totalSkills]
  );

  return <TagList tags={tags} />;
};
